import { arrayMap } from "../utils/array.utils";
import Button from "./Button";

export function GroupBtn({ btns = [], justify = "end", loading = false }) {
  return (
    <div className={`d-flex flex-wrap gap-1 justify-content-${justify}`}>
      {arrayMap(btns, (item, index) => (
        <Button key={index + 1} {...item} disabled={loading} />
      ))}
    </div>
  );
}
